import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useReviewsAggregate } from '../../../hooks/useReviews'
import OfferingDetailsModal from './OfferingDetailsModal'

/** Build one "offering" per skill (the API only exposes a single rate/duration
 * per astrologer, so every offering shares that price — there's no per-skill
 * pricing endpoint yet). Falls back to a single generic offering with no skills. */
export function buildOfferings(astro, ratingLabel) {
  const skills = astro.skills.length ? astro.skills : ['Vedic Astrology']
  return skills.map((skill) => ({
    key: skill,
    label: skill,
    title: `${skill} Session`,
    desc: `Personalised guidance in ${skill.toLowerCase()} from ${astro.name}.`,
    price: astro.price,
    priceLabel: astro.priceLabel,
    duration: astro.duration,
    rating: ratingLabel,
  }))
}

export default function AstrologerOfferingsSection({ astro }) {
  // Same live-reviews source as the hero above it on this page — the
  // astrologer record's own rating/reviews_count aren't kept in sync
  // upstream. Shares AstrologerProfileHeroSection's query cache (identical
  // key), so this doesn't add a second network request.
  const { summary } = useReviewsAggregate('astrologer', astro.id)
  const ratingLabel = summary.totalReviews > 0 ? summary.averageRating.toFixed(1) : 'New'
  const offerings = buildOfferings(astro, ratingLabel)
  const [selected, setSelected] = useState(null)

  return (
    <div className="info-card p-6 sm:p-8 space-y-5">
      <h2 className="text-xl font-cinzel text-[#1C140A]">Consultations offered</h2>
      <div className="grid gap-4 sm:grid-cols-2">
        {offerings.map((o) => (
          <article
            key={o.key}
            role="button"
            tabIndex={0}
            onClick={() => setSelected(o)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                setSelected(o)
              }
            }}
            className="rounded-2xl border border-[#D7C29A]/25 p-5 hover:border-secondary/40 transition-colors cursor-pointer"
          >
            <div className="flex items-center justify-between gap-3">
              <span className="meta-pill text-[10px]!">{o.label}</span>
              <span className="text-[#C8922A] font-semibold text-sm">★ {o.rating}</span>
            </div>
            <h3 className="mt-3 text-base font-bold text-[#1C140A]">{o.title}</h3>
            <p className="mt-1.5 text-xs leading-relaxed text-[#5C3A18]">{o.desc}</p>
            {/* <div className="mt-4 flex items-center justify-between">
              <span className="text-sm font-bold text-[#C8922A]">
                {o.priceLabel} <span className="text-[10px] font-medium text-[#8B7355]">/ {o.duration} min</span>
              </span>
              <Link to="#book-slot" className="text-[11px] font-semibold uppercase tracking-wide text-[#1C140A] hover:text-secondary transition-colors">
                View →
              </Link>
            </div> */}
          </article>
        ))}
      </div>
      <OfferingDetailsModal offering={selected} onClose={() => setSelected(null)} />
    </div>
  )
}
